import { useState } from 'react';
import { PersonCard } from 'pages/AboutUs/Management/PersonCard';
import styles from 'pages/AboutUs/Management/tabs/Tabs.scss';

export const Presidium = ({ data: management }) => {
  const [openPersonId, setOpenPersonId] = useState(null);

  const handleToggle = (id) => setOpenPersonId((prevId) => (prevId === id ? null : id));

  const presidiumMembers = management?.filter(({ subdivision }) => subdivision === 'Presidium') ?? [];

  return (
    <section className={styles.membersList}>
      {presidiumMembers.map((person) => (
        <PersonCard
          person={person}
          isOpen={openPersonId === person.id}
          onToggle={() => handleToggle(person.id)}
          key={person.id}
        />
      ))}
    </section>
  );
};
